import React, { Component } from "react";
import { connect } from "react-redux";
import OriginList from "./originList";
import CreateOriginData from "./createOrigin";
import Button from "@mui/material/Button";
import "../../assets/css/settings.css";
import { fetchOrigins } from "../../api/origin";
import {
  fetchOriginsRequest,
  fetchOriginsSuccess,
  fetchOriginsFailure,
} from "../../actions/origin";
import Grid from "@mui/material/Grid";
import { TextField } from "@mui/material";
import "../../assets/css/origin.css";

import { fetchCompanies } from "../../api/company";
import { fetchDeliveryMethod } from "../../api/deliveryMethod";
import CompanyContext from "../../helpers/CompanyContext"; 

class OriginPage extends Component {
  static contextType = CompanyContext; 

  constructor(props) {
    super(props);
    this.state = {
      isPopupOpen: false,
      isOriginDetailsOpen: false,
      companies: [],
      deliveryMethods: [],
      searchText: "",
      selectedOrigin: null,
      previousCompanyId: null, 
    };
  }

  fetchData = () => {
    this.props.fetchOriginsRequest();
    fetchOrigins()
      .then((data) => {
        console.log("origins fetched:", data);
        this.props.fetchOriginsSuccess(data);
      })
      .catch((error) => this.props.fetchOriginsFailure(error));

    fetchCompanies()
      .then((data) => {
        console.log("companies:", data);
        this.setState({ companies: data });
      })
      .catch((error) => {
        console.error("Error fetching company detail: ", error);
      });

    fetchDeliveryMethod()
      .then((data) => {
        console.log("delivery methods:", data);
        this.setState({ deliveryMethods: data });
      })
      .catch((error) => {
        console.error("Error fetching delivery methods: ", error);
      });
  };

  componentDidMount() {
    this.fetchData();
    
    // Store initial company ID
    const { selectedCompany } = this.context;
    this.setState({ previousCompanyId: selectedCompany });
  }

  // Check for company changes
  componentDidUpdate(prevProps, prevState) {
    const { selectedCompany } = this.context;
    
    // If company changed, refetch data
    if (selectedCompany !== this.state.previousCompanyId) {
      console.log("🔄 Company changed in Origin page, refetching data...");
      this.setState({ 
        previousCompanyId: selectedCompany,
        searchText: "", // Reset search
        isPopupOpen: false, // Close any open popups
        isOriginDetailsOpen: false,
        selectedOrigin: null,
      });
      this.fetchData();
    }
  }

  handleOpenPopup = () => {
    this.setState({
      isPopupOpen: true,
      searchText: "",
      isOriginDetailsOpen: false,
    });
  };

  handleClosePopup = () => {
    this.setState({ isPopupOpen: false });
  };

  handleSelectedOrigin = (selectedOrigin) => {
    this.setState({
      selectedOrigin,
      isPopupOpen: false,
      isOriginDetailsOpen: true,
    });
  };

  handleCloseSelectedOrigin = () => {
    this.setState({
      isOriginDetailsOpen: false,
    });
  };

  handleSearchChange = (event) => {
    this.setState({ searchText: event.target.value.toLowerCase() });
  };

  render() {
    const { searchText, selectedOrigin, companies, deliveryMethods } =
      this.state;
    const { origins } = this.props;
    return (
      <div className="origin-page">
        <h4 className="text-center text-acumen-color">Origins</h4>
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            sm={3}
            style={{ marginBottom: "16px", padding: "16px" }}>
            {this.state.isPopupOpen && (
              <CreateOriginData
                handleClose={this.handleClosePopup}
                companies={companies}
                deliveryMethods={deliveryMethods}
              />
            )}
            <TextField
              id="outlined-search"
              label="Search Origins"
              type="search"
              value={this.state.searchText}
              onChange={this.handleSearchChange}
              style={{ margin: "0px", padding: "0" }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={9}
            style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-start", padding: "16px" }}>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleOpenPopup}>
              Add Origin
            </Button>
          </Grid>
        </Grid>
        <br />
        <br /> <br />
        <br />
        <Grid item xs={12} sm={4}>
          <OriginList
            origins={origins}
            searchText={searchText}
            companies={companies}
            deliveryMethods={deliveryMethods}
            onOriginSelect={this.handleSelectedOrigin}
          />
          {this.state.isOriginDetailsOpen && selectedOrigin ? (
            <CreateOriginData
              handleClose={this.handleCloseSelectedOrigin}
              companies={companies}
              deliveryMethods={deliveryMethods}
              originId={selectedOrigin.id}
            />
          ) : (
            <></>
          )}
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    origins: state.origins,
  };
};

const mapDispatchToProps = {
  fetchOriginsRequest,
  fetchOriginsSuccess,
  fetchOriginsFailure,
};

export default connect(mapStateToProps, mapDispatchToProps)(OriginPage);